import styled from 'styled-components';
import { HIGHLIGHT_COLUMNS, ON_CLICK_OPEN_COLUMNS } from './constants';

export const Adornment = styled.div`
  padding-left: 12px;
  display: grid;
  place-content: center;
`;

export const EmptyTable = styled.div`
  min-height: calc(100vh - 136px);
  display: grid;
  place-content: center;
  line-height: 24px;
  color: #000000;
  text-align: center;
  svg {
    margin: 0 auto;
  }
  div.reason {
    font-weight: 600;
    font-size: 13px;
    margin: 8px 0;
  }
  div.suggession {
    font-size: 13px;
  }
`;

export const FieldRow = styled.div`
  display: flex;
  align-items: center;
  span.cbx-text {
    font-size: 14px;
    line-height: 17px;
    color: #1b334b;
  }
  div.dragger {
    min-width: 8px;
    cursor: grab;
    margin-right: 18px;
  }
  :not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const DisplayBox = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 8px;
  &.full-width {
    width: 100%;
  }
  strong {
    font-weight: 600;
  }
  & > * {
    margin: 0 4px;
  }
  div.divider {
    background: #bbdcfe;
    width: 1px;
    height: 24px;
  }
  div.text-content {
    font-size: 14px;
    line-height: 20px;
    color: #12344d;
    word-break: break-word;
  }
  &.info {
    background: #e5f2fd;
    border: 1px solid #bbdcfe;
    div.divider {
      background: #bbdcfe;
    }
    div.text-content {
      color: #12344d;
    }
  }
  &.error {
    background: #fef1e1;
    border: 1px solid #fddbb5;
    div.divider {
      background: #fddbb5;
    }
    div.text-content {
      color: #475867;
    }
  }
  &.warn {
    background: #ffecf0;
    border: 1px solid #ffd0d6;
    div.divider {
      background: #ffd0d6;
    }
    div.text-content {
      color: #12344d;
    }
  }
`;

export const ConfirmationText = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #3b3b3b;
  margin-bottom: 12px;
`;

export const ConfirmationBody = styled.div`
  & > :not(:last-child) {
    margin-bottom: 12px;
  }
  max-width: 512px;
  label {
    color: var(--color-elephant-900);
  }
`;

export const AddFilters = styled.div`
  padding: 8px 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: rgb(44, 92, 197);
`;

export const TableDataContainer = styled.div<{ width?: string | number }>`
  height: 100%;
  display: flex;
  &.templates-table,
  &.user-management-table {
    height: unset;
    .table-content {
      margin: 0;
      .table-wrapper {
        margin: 0;
      }
    }
  }
  table {
    border-radius: 4px;
    overflow: hidden;
  }
  .fui-table {
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
  .table-actions {
    min-height: 56px;
    width: ${({ width }) => width || 'calc(100vw - 64px)'};
    z-index: 1100;
    margin-bottom: 0;
  }
  .pagination-text {
    padding: 0 8px;
    text-align: center;
  }
  .table-content {
    flex: 1;
    overflow: auto;
  }
  .table-wrapper {
    overflow: auto;
    padding: unset;
    margin: 10px;
    th:first-child {
      border-top-left-radius: 5px;
    }
    th:last-child {
      border-top-right-radius: 5px;
    }
    tr:last-child {
      border-radius: 5px;
      td:first-child {
        border-bottom-left-radius: 5px;
      }
      td:last-child {
        border-bottom-right-radius: 5px;
      }
    }
  }
  .table-filters {
    padding: 0;
  }
  tfoot {
    td {
      background-color: unset !important;
    }
  }
  th {
    font-size: 12px;
    font-weight: 600;
    padding: 12px 12px;
    text-align: left;
    .table-checkbox {
    }
  }
  td {
    max-width: 256px;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 12px 12px;
    white-space: nowrap;
    .table-checkbox {
      padding-left: 12px;
    }
  }
  ${ON_CLICK_OPEN_COLUMNS.map((cn) => `td.${cn}`).join(', ')} {
    cursor: pointer;
    font-weight: 500;
    :hover {
      color: #2c5cc5;
    }
  }
  ${HIGHLIGHT_COLUMNS.map((cn) => `td.${cn}`).join(', ')} {
    font-weight: 500;
  }
`;

export const SelectAllContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 3;
  background: #ffffff;
  border-radius: 4px;
  font-weight: 500;
  font-size: 13px;
  padding: 8px 0;
  text-align: center;
  color: #12344d;
  box-shadow: 0 2px 4px 0 rgb(24 50 71 / 8%);
`;

export const ActionButton = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 13px;
  color: var(--color-elephant-900);
  display: flex;
  align-items: center;
  padding: 4px;
  cursor: pointer;
  width: fit-content;
  &.disabled {
    opacity: 50%;
    pointer-events: none;
  }
  div:first-child {
    margin-right: 6px;
    width: 12px;
    height: 12px;
  }
`;
